import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMeasures from '../../reducers/measures/measures.reducer';

export const selectMeasuresState = createFeatureSelector<fromMeasures.State>(
    fromMeasures.measuresFeatureKey
);

export const selectCurrentMeasureEdit = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) => state.measure
)

export const selectMeasureTableData = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) => state.measuresData
)

export const selectMeasureAggregationList = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) => state.dropDownMeasureAggregationType
)

export const selectMeasureTypeList = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) => state.dropDownMeasureTypes
)

export const selectCriteriaList = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) => state.criterias
)

// Allow user to add new population criteria once all other critera objects have 
// been created with a valid criteria
export const canAddCriteria = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) =>
        state.criterias.filter( criteria => criteria.id == -1).length == 0 
)

export const showMeasureDetails = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) => state.showMeasureDetails
)

export const selectCriteraiGroupList = createSelector(
    selectMeasuresState,
    (state: fromMeasures.State) => state.criteriaGroup
)


